<template>
  <v-dialog v-model="dialogPackageDetail" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title> {{isChinessLanguage ? '打包日' : 'Đóng bao ngày'}}  {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-checkbox :label="isChinessLanguage ? '使用扫码机' : 'Sử dụng máy đọc barcode'" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  :label="isChinessLanguage ? '运单号' : 'Mã vận đơn'"
                  ref="trancode"
                  v-model="currentTransaction.TransactionCode"
                  class="input-group--focused"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                  :disabled="readOnly || currentItem.ReceivePlaceID == 0"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table
                  :headers="isChinessLanguage  ? cn_headers : headers"
                  :items="currentItem.Packages"
                  :server-items-length="currentItem.Packages.length"
                  :options.sync="pagination"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.TransactionCode }}</td>
                      <!-- <td>{{ item.FeeShip | currency}}</td> -->
                      <td class="text-center">
                        <v-icon v-if="!readOnly" small @click="deleteTransaction(item.ID)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap pl-5>
                <v-flex lg8 md8 sm12 pa-0>
                  <v-text-field
                    :label="isChinessLanguage ? '货物单号 (auto)' : 'Mã bao hàng (auto)'"
                    :disabled="autoPackageCode"
                    v-model="currentItem.PackageCode"
                    :rules="packcodeRules"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 md4 sm12 pa-0>
                  <v-text-field
                    :label="isChinessLanguage ? '货物单号 (ex)' : 'Mã bao hàng (ex)'"
                    v-model="currentItem.SubPackageCode"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <h-currency-input
                    :label="isChinessLanguage ? '包裹数量' : 'Số gói hàng'"
                    v-model="currentItem.Volume"
                    :decimal="0"
                    :disabled="readOnly"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <h-currency-input
                    :label="isChinessLanguage ? '总运费' : 'Tổng phí ship'"
                    v-model="currentItem.Amount"
                    :decimal="0"
                    class="input-group--focused"
                    disabled
                  ></h-currency-input>
                </v-flex> -->
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    :label="isChinessLanguage ? '总重量' : 'Tổng cân nặng'"
                    type="number"
                    v-model="currentItem.Weight"
                    class="input-group--focused"
                    :rules="requireRules"
                    :disabled="readOnly"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    :label="(isChinessLanguage ? '长度' : 'Chiều dài') + '(cm)'"
                    type="number"
                    v-model="currentItem.Length"
                    class="input-group--focused"
                    :disabled="readOnly"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    :label="(isChinessLanguage ? '宽度' : 'Chiều rộng') + '(cm)'"
                    type="number"
                    v-model="currentItem.Width"
                    class="input-group--focused"
                    :disabled="readOnly"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    :label="(isChinessLanguage ? '高度' : 'Chiều cao') + '(cm)'"
                    type="number"
                    v-model="currentItem.Height"
                    class="input-group--focused"
                    :disabled="readOnly"
                  ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-select
                    class="pa-0"
                    :label="isChinessLanguage ? '仓库' : 'Kho nhận'"
                    :items="warehouses"
                    v-model="currentItem.ReceivePlaceID"
                    item-text="Name"
                    item-value="ID"
                    :rules="requireRules"
                    :disabled="readOnly"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!readOnly" :disabled="!CorrectData" color="blue darken-1 white--text" @click="saveItem">{{isChinessLanguage ? '仓库' : 'Đóng bao'}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
export default {
  name: "big-package-popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      valid: true,
      useBarcodeReader: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      currentTransaction: {
        TransactionCode: ""
      },
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        // {
        //   text: "Phí ship",
        //   value: "FeeShip",
        //   filterable: true,
        //   dataType: dataType["Number"]
        // },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      cn_headers: [
        {
          text: '运单号',
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        // {
        //   text: '运费',
        //   value: "FeeShip",
        //   filterable: true,
        //   dataType: dataType["Number"]
        // },
        {
          text: '操作',
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      packcodeRules: [v => (!this.autoPackageCode && !!v) || "Mã bao không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [5] },
      currentTime: getCurrentTime()
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    dialogPackageDetail() {
      if (this.dialogPackageDetail) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading,
      warehouses: state => state.commons.stores,
    }),
    CorrectData() {
      return (this.currentItem.PackageCode != '' || this.autoPackageCode) && this.currentItem.Weight > 0 && this.currentItem.Packages.length > 0 && this.currentItem.ReceivePlaceID > 0;
    },
    roleStoreTQ() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
    },
    isChinessLanguage() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ && this.$store.state.authentication.user.ischinesslanguage;
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    filter_data: function() {
      if (this.currentItem.ID > 0) {
        var param = {
          pagination: this.pagination
        };
        this.$store.dispatch("bigPackage/getDetail", {'id': this.currentItem.ID, 'param': param});
      }
    },
    deleteTransaction(id) {
      _.remove(this.currentItem.Packages, pkg => pkg.ID === id);
      this.currentItem.Volume = this.currentItem.Packages.length;
      this.currentItem.Amount =  _.sumBy(this.currentItem.Packages, 'FeeShip');
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveItem() {
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ...this.currentItem,
          PackageCode: this.currentItem.PackageCode && this.currentItem.PackageCode != '' ? this.currentItem.PackageCode : null,
          'Packages': _.map(this.currentItem.Packages, "ID")
        },
        id: this.currentItem.ID
      });
      this.$emit("closePopup");
    },
    manualChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
         var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            },
            {
                column: "StoreCNImportDate",
                condition: "not_null"
            },
            {
                column: "BigPackageID",
                value: 0,
                condition: "equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại trong bao.')
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            if(ret.data[0].ReceivePlaceID > 0 && ret.data[0].ReceivePlaceID != this.currentItem.ReceivePlaceID){
              sendErrorNotice('Mã vận đơn không khớp kho nhận.')
              return;
            }

            this.currentItem.Packages.unshift(ret.data[0]);
            this.currentItem.Volume = this.currentItem.Packages.length;
            this.currentItem.Amount =  _.sumBy(this.currentItem.Packages, 'FeeShip');
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            sendErrorNotice('Mã vận đơn chưa nhập kho hoặc đã đóng trong bao khác.')
          }              
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
   
  },
  mounted() {
    this.$store.dispatch("commons/getAllStores");
  }
};
</script>
